var React = require('react');

function PatternRound (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mask"),React.createElement("circle",{"cx":"207","cy":"563","r":"87","transform":"translate(-120 -476)","fill":"#01A9E4","fillRule":"evenodd","key":1})]);
}

PatternRound.defaultProps = {"width":"174","height":"174","viewBox":"0 0 174 174"};

module.exports = PatternRound;

PatternRound.default = PatternRound;
